import styles from '../../assets/scss/components/home/footer.module.scss'
import { Link, useLocalization, Image } from '@shopify/hydrogen'
import { useI18n } from '../i18n.client'
import { EnhancedMenu } from '../../lib/menus'
import { classNames } from '@shopify/css-utilities'
import { motion } from 'framer-motion'
import { LanguageCode } from '@shopify/hydrogen/storefront-api-types'
import { LanguageSwitch } from '../language/language-switch.client'
import { NewsletterForm } from '../newsletter-form.client'

export const Footer: React.FC<{
  companyMenu: EnhancedMenu
  helpMenu: EnhancedMenu
  legalMenu: EnhancedMenu
  shopMenu: EnhancedMenu
}> = ({ companyMenu, helpMenu, legalMenu, shopMenu }) => {
  const [i18n] = useI18n()
  const date = new Date()

  return (
    <motion.footer
      animate={{ opacity: 1, transition: { delay: 1 } }}
      className={styles.footerOuterContainer}
      initial={{ opacity: 0 }}
      transition={{ ease: [0, 0, 0, 1] }}>
      <div className={styles.footerInnerContainer}>
        <div className={styles.footer}>
          <img
            alt="Marie Lichtenberg"
            decoding="async"
            height={12}
            loading="lazy"
            src="/marie-lichtenberg-logotype-green.svg"
            width={250}
          />
          <div className="section px">
            <div className={styles.grid}>
              {[shopMenu, helpMenu, companyMenu, legalMenu].map((menu) => (
                <Menu key={menu.id} menu={menu} />
              ))}
              <div className={styles.newsletter}>
                <Image alt={i18n.translate('loop-me-in')} height={36} src="/loop-me-in.svg" width={185} />
                <p>{i18n.translate('newsletter-sign-up')}</p>
                <NewsletterForm variant="newsletter_subscription_footer" />
              </div>
            </div>
            <div className={styles.smallPrintContainer}>
              <div className={styles.smallPrint}>
                <div className={styles.copyright}>
                  &copy; Marie Lichtenberg {date.getFullYear()}. {i18n.translate('all-rights-reserved')}
                </div>
                <Link className={styles.credits} to="https://y-wilson.com/" target="_blank">
                  {i18n.translate('website-design-and-build-by-y-wilson')}
                </Link>
              </div>
              <div className={styles.stamp}>
                <a href="mailto:hello@marielichtenberg.com">
                  <img
                    alt="hello@marielichtenberg.com"
                    decoding="async"
                    height={23}
                    loading="lazy"
                    src="/footer-stamp-top.png"
                    width={531}
                  />
                </a>
                <img
                  alt="www.marielichtenberg.com"
                  decoding="async"
                  height={101}
                  loading="lazy"
                  src="/footer-stamp-bottom.png"
                  width={531}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.languageSwitch}>
        <LanguageSwitch isWhite />
      </div>
    </motion.footer>
  )
}

const Menu: React.FC<{ menu: EnhancedMenu }> = ({ menu }) => {
  const {
    language: { isoCode: language },
  } = useLocalization()

  return (
    <div className={styles.menu}>
      <div className={styles.menuTitle}>
        {menu.title === 'Company' && language === LanguageCode.Fr ? 'Marie Lichtenberg' : menu.title}
      </div>
      {menu.items.map(({ id, title, to }) => (
        <Link className={classNames('underline green', styles.menuLink)} key={id} to={to}>
          <span className="target">{title}</span>
        </Link>
      ))}
    </div>
  )
}
